<template>
    <div><!-- 部材品質異常聯絡單 -->
        <SearchBar  @unElQueryEvent="doUnElSearch" @unElExportEvent="doUnElExport"/>
        <CCard>
            <CCardBody>
                <table class="table ">
                    <thead class="thead-light">
                        <tr>
                            <th class="text-center">{{headers[0]}}</th>
                            <th class="text-center">{{headers[1]}}</th>
                            <th class="text-center">{{headers[2]}}</th>
                            <th class="text-center">{{headers[3]}}</th>
                            <th class="text-center">{{headers[4]}}</th>
                            <th class="text-center">{{headers[5]}}</th>
                            <th class="text-center">{{headers[6]}}</th>
                            <th class="text-center">{{headers[7]}}</th>
                            <th class="text-center">{{headers[8]}}</th>
                            <th class="text-center">{{headers[9]}}</th>
                            <th class="text-center">{{headers[10]}}</th>
                            <th class="text-center">{{headers[11]}}</th>
                            <th class="text-center">{{headers[12]}}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item , index) in unElSearchResult" :key="index">                        
                            <td class="text-center">{{fixDate(item.happenDate)}}</td>
                            <td class="text-center">{{item.customerName}}</td>
                            <td class="text-center" v-if="item.dDown_Trial === 'MP'">量產</td>
                            <td class="text-center" v-else-if="item.dDown_Trial === 'TR'">試作</td>
                            <td class="text-center" v-else></td>
                            <td class="text-center">{{item.partnumber}}</td>
                            <td class="text-center">{{item.partname}}</td>
                            <td class="text-center">{{item.happenTypeTxt}}</td>
                            <td class="text-center">{{item.carCnt}}</td>
                            <td class="text-center">{{item.carRatio}}</td>
                            <td class="text-center">{{item.carContent}}</td>
                            <td class="text-center">
                                <div v-html="getCarFileLink(item)"></div>                                
                            </td>
                            <td class="text-center">{{item.carStatusTxt}}</td>
                            <td class="text-center">{{fixDate(item.carEnddate)}}</td>
                            <td class="text-center">
                                <button class="btn btn-sm btn-danger mr-2" @click="deleteRowEvent(item)" v-if="isShowDelBtn(item)">{{i18n('Buttons.Delete')}}</button>
                                <router-link class="btn btn-sm btn-success"  @click.native="editRowEvent(item)" to="">{{editBtnText(item)}}</router-link>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </CCardBody>
        </CCard>        
    </div>
</template>
<script>
import SearchBar from './SearchBar'
import { qualityMixin } from '@/mixin/quality'
import { mapGetters } from 'vuex'
export default {
    mixins: [qualityMixin],	
    components: {
        SearchBar
    },
    data() {
        return {
            headers :[
                this.i18n("Element.OccuranceDates"),this.i18n("Element.Vendor"),this.i18n("Element.TrialMassProduction"),
                this.i18n("Element.PartNumber"),this.i18n("Element.Parts"),this.i18n("Element.OccuranceType"),
                this.i18n("Element.NumberOfAbnormalities"),this.i18n("Element.DefectRate"),this.i18n("Element.ContentOfAbnormalities"),this.i18n("Element.FileUpload"),
                this.i18n("Element.Status"),this.i18n("Element.ClosingDate"),this.i18n("Element.Function")
            ],
            carStatusList: this.$t('carStatusList'), //狀態 清單
            carHappenTypeList: this.$t('carHappenTypeList'), //發生類別 清單
            unElSearchResult : []
        }
    },
    props : {
    },
    watch: {
        "lang": function() {
            this.headers = [
                this.i18n("Element.OccuranceDates"),this.i18n("Element.Vendor"),this.i18n("Element.TrialMassProduction"),
                this.i18n("Element.PartNumber"),this.i18n("Element.Parts"),this.i18n("Element.OccuranceType"),
                this.i18n("Element.NumberOfAbnormalities"),this.i18n("Element.DefectRate"),this.i18n("Element.ContentOfAbnormalities"),this.i18n("Element.FileUpload"),
                this.i18n("Element.Status"),this.i18n("Element.ClosingDate"),this.i18n("Element.Function")
            ]

            this.carStatusList = this.$t('carStatusList') //狀態 清單
            this.carHappenTypeList = this.$t('carHappenTypeList') //發生類別 清單
        }
    },
    methods: {
        doUnElSearch (param){
            const url = `${this.$apiUrl_Quality}/SearchUnusualElement`;
            this.updateLoading(true);
            this.axios.post(url, param).then((response) => {
                const {status , statusMessage} = response.data;
                this.updateLoading(false);
                if(status){
                    this.$alert(statusMessage,'警告',{type: 'warning'});
                }else{                    
                    //--成功          
                    const carStatusMap= this.listToMap(this.carStatusList, 'carStatusId' ,'carStatusCaption');
                    const carHappenMap= this.listToMap(this.carHappenTypeList, 'happenTypeId' ,'happenTypeCaption');
                    const rows = response.data;
                    rows.forEach(r => {
                        const rowStatus = ''+r.carStatus;                        
                        r.carStatusTxt = carStatusMap[rowStatus];
                        r.happenTypeTxt = carHappenMap[r.happenType];
                    });
                    this.unElSearchResult = rows;
                    this.setCacheQueryParam('UnEl_QueryParam' , param);                           
                }                    
            }); 
        },
        doUnElExport(param){
            const url = `${this.$apiUrl_Quality}/PrepareSearchUnusualElementExport`;
            this.axios.post(url, param).then((response) => {                        
                const respObj = response.data;                 
                const exportExcelToken = respObj.token;
                let urlExcel = `${this.$apiUrl_Quality}/SearchUnusualElementExportExcel/${exportExcelToken}`;
                this.openNewTabByALink('UnElExportExcel',urlExcel);
            })
        },
        deleteRowEvent (item){ //刪除
            const self =this;
            this.$confirm('此操作將永久刪除該筆資料, 是否繼續?', '提示', {
                confirmButtonText: '確定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                self.doDeleteRow(item.carGuid);
            });
        },
        doDeleteRow (carGuid){//呼叫刪除處理
            const url = `${this.$apiUrl_Quality}/DeleteUnusualElementRow`;
            this.updateLoading(true);
            const param = { guid: carGuid};
            const self =this;
            this.axios.post(url, param).then((response) => {
                const {status , statusMessage} = response.data;
                this.updateLoading(false);
                if(status){
                    this.$alert(statusMessage,'警告',{type: 'warning'});
                }else{                    
                    //--成功
                    let queryParam= {};
                    self.getCacheQueryParam('UnEl_QueryParam' , queryParam);  
                    self.doUnElSearch(queryParam);
                }                    
            }); 
        },
        editRowEvent (item){ //維護 / 詳細資訊                        
            sessionStorage.setItem('carGuid', item.carGuid);
            this.$router.push('elementinformation');
        },
        isShowDelBtn (item){
            if(!this.isMember){
                return true;
            } 
            return false;
        },
        editBtnText (item){
            //4未上傳/0待審核(待判定)/1結案/2退件/3完成並效果追蹤，非退件不得刪除
            if(item.carStatus === 0){
                return this.i18n('Buttons.Maintain');               
            }else if(item.carStatus === 4){
                if(this.isMember){
                    return this.i18n('Buttons.Maintain');
                }                
            }else if(item.carStatus === 2){
                return this.i18n('Buttons.Maintain');
            }else if(item.carStatus === 3){
                if(this.isQMmanager){
                    return this.i18n('Buttons.Maintain');
                }                
            }
            return this.i18n('Buttons.DetailInfo');
        },
        getCarFileLink (item){
            const baseUrl = this.$apiUrl_Quality;
            if(item.carFile){
                const file = this.fixFileName(item.carFile);
                 return `<a class="fileLink" target="_blank" href="${baseUrl}/CarDownload/${item.carGuid}">${file}</a>`;
            }
            return '';
        },
        i18n (keyStr){
            return this.$t(keyStr);
        },
    },
    computed: {
        ...mapGetters(["lang"])
    },
	mounted() {        
	},
    created() {        
    }
}
</script>

<style lang="scss" scoped>
table th:first-child {
    text-align: center;
    padding: 15px 5px;
}

.table th {
    background-color: #303c50;
    color: #fff;
}

.table tr:nth-child(even) {
    background-color: transparent;
}
.card-body {
    overflow-x: auto;
}
</style>



